<template>
  <div>
    <v-overlay :value="loading">
      <v-progress-circular
          :size="70"
          :width="7"
          color="white"
          indeterminate
      ></v-progress-circular>
    </v-overlay>

    <h1 id="release-date-header">Release: {{release.release_date}}</h1>
    <div class="release-container" v-html="release.release_notes"></div>

  </div>
</template>
<script>
import ReleasesService from "@/services/releases.service";

export default {
  name: "SingleRelease",
  data(){
    return{
      release:'',
      loading:false
    }
  },
  created() {
    this.loading=true
    ReleasesService.getSingleRelease(this.$route.params.id).then(res => {
      this.release = res
    }).finally(()=> this.loading = false  )
    // this.release = {
    //   "release_id": 12,
    //   "release_date": "8/24/2023",
    //   "release_notes": "<h1 id=\"user-interface-v2-1-9\">User Interface - v2.1.9</h1>\r\n<h2 id=\"added\">Added</h2>\r\n<ul>\r\n<li><a href=\"https://git.hph.io/michael/erc-api/-/issues\">issues/500</a> - Feature request completed.</li>\r\n</ul>\r\n<h2 id=\"changed\">Changed</h2>\r\n<ul>\r\n<li><a href=\"https://git.hph.io/michael/erc-api/-/issues\">issues/437</a> - Move Client ID and EIN to top right of card on client profile card.</li>\r\n<li><a href=\"https://git.hph.io/michael/erc-api/-/issues\">issues/438</a> - Move address and contact information on client summary</li>\r\n<li><a href=\"https://git.hph.io/michael/erc-api/-/issues\">issues/439</a> - Update formatting of PPP round cards, Owners and Family, TSSW, and Employee counts</li>\r\n<li><a href=\"https://git.hph.io/michael/erc-api/-/issues\">issues/441</a> - Package generation card updates</li>\r\n</ul>\r\n<h2 id=\"deprecated\">Deprecated</h2>\r\n<ul>\r\n<li>Nothing is being discontinued in this release.<h2 id=\"removed\">Removed</h2>\r\n</li>\r\n<li>Nothing was removed from this release</li>\r\n</ul>\r\n<h2 id=\"fixed\">Fixed</h2>\r\n<ul>\r\n<li><a href=\"https://git.hph.io/michael/erc-api/-/issues\">issues/435</a> - on hold toggle to comply with material design</li>\r\n</ul>\r\n<h2 id=\"security\">Security</h2>\r\n<ul>\r\n<li>No known security issues.</li>\r\n</ul>\r\n<h1 id=\"api-business-logic-and-reporting-v3-1-5\">API (Business logic and reporting) - v3.1.5</h1>\r\n<h2 id=\"added\">Added</h2>\r\n<ul>\r\n<li><a href=\"https://git.hph.io/michael/erc-api/-/issues\">issues/500</a> - Feature request completed.</li>\r\n</ul>\r\n<h2 id=\"changed\">Changed</h2>\r\n<ul>\r\n<li><a href=\"https://git.hph.io/michael/erc-api/-/issues\">issues/437</a> - Move Client ID and EIN to top right of card on client profile card.</li>\r\n<li><a href=\"https://git.hph.io/michael/erc-api/-/issues\">issues/438</a> - Move address and contact information on client summary</li>\r\n<li><a href=\"https://git.hph.io/michael/erc-api/-/issues\">issues/439</a> - Update formatting of PPP round cards, Owners and Family, TSSW, and Employee counts</li>\r\n<li><a href=\"https://git.hph.io/michael/erc-api/-/issues\">issues/441</a> - Package generation card updates</li>\r\n</ul>\r\n<h2 id=\"deprecated\">Deprecated</h2>\r\n<ul>\r\n<li>Nothing is being discontinued in this release.<h2 id=\"removed\">Removed</h2>\r\n</li>\r\n<li>Nothing was removed from this release</li>\r\n</ul>\r\n<h2 id=\"fixed\">Fixed</h2>\r\n<ul>\r\n<li><a href=\"https://git.hph.io/michael/erc-api/-/issues\">issues/435</a> - on hold toggle to comply with material design</li>\r\n</ul>\r\n<h2 id=\"security\">Security</h2>\r\n<ul>\r\n<li>No known security issues.</li>\r\n</ul>\r\n<h1 id=\"database-v2-2\">Database - v2.2</h1>\r\n<h2 id=\"added\">Added</h2>\r\n<ul>\r\n<li><a href=\"https://git.hph.io/michael/erc-api/-/issues\">issues/500</a> - Feature request completed.</li>\r\n</ul>\r\n<h2 id=\"changed\">Changed</h2>\r\n<ul>\r\n<li><a href=\"https://git.hph.io/michael/erc-api/-/issues\">issues/437</a> - Move Client ID and EIN to top right of card on client profile card.</li>\r\n<li><a href=\"https://git.hph.io/michael/erc-api/-/issues\">issues/438</a> - Move address and contact information on client summary</li>\r\n<li><a href=\"https://git.hph.io/michael/erc-api/-/issues\">issues/439</a> - Update formatting of PPP round cards, Owners and Family, TSSW, and Employee counts</li>\r\n<li><a href=\"https://git.hph.io/michael/erc-api/-/issues\">issues/441</a> - Package generation card updates</li>\r\n</ul>\r\n<h2 id=\"deprecated\">Deprecated</h2>\r\n<ul>\r\n<li>Nothing is being discontinued in this release.<h2 id=\"removed\">Removed</h2>\r\n</li>\r\n<li>Nothing was removed from this release</li>\r\n</ul>\r\n<h2 id=\"fixed\">Fixed</h2>\r\n<ul>\r\n<li><a href=\"https://git.hph.io/michael/erc-api/-/issues\">issues/435</a> - on hold toggle to comply with material design</li>\r\n</ul>\r\n<h2 id=\"security\">Security</h2>\r\n<ul>\r\n<li>No known security issues.</li>\r\n</ul>\r\n<h1 id=\"erc-engine-v4-0\">ERC Engine - v4.0</h1>\r\n<h2 id=\"added\">Added</h2>\r\n<ul>\r\n<li><a href=\"https://git.hph.io/michael/erc-api/-/issues\">issues/500</a> - Feature request completed.</li>\r\n</ul>\r\n<h2 id=\"changed\">Changed</h2>\r\n<ul>\r\n<li><a href=\"https://git.hph.io/michael/erc-api/-/issues\">issues/437</a> - Move Client ID and EIN to top right of card on client profile card.</li>\r\n<li><a href=\"https://git.hph.io/michael/erc-api/-/issues\">issues/438</a> - Move address and contact information on client summary</li>\r\n<li><a href=\"https://git.hph.io/michael/erc-api/-/issues\">issues/439</a> - Update formatting of PPP round cards, Owners and Family, TSSW, and Employee counts</li>\r\n<li><a href=\"https://git.hph.io/michael/erc-api/-/issues\">issues/441</a> - Package generation card updates</li>\r\n</ul>\r\n<h2 id=\"deprecated\">Deprecated</h2>\r\n<ul>\r\n<li>Nothing is being discontinued in this release.<h2 id=\"removed\">Removed</h2>\r\n</li>\r\n<li>Nothing was removed from this release</li>\r\n</ul>\r\n<h2 id=\"fixed\">Fixed</h2>\r\n<ul>\r\n<li><a href=\"https://git.hph.io/michael/erc-api/-/issues\">issues/435</a> - on hold toggle to comply with material design</li>\r\n</ul>\r\n<h2 id=\"security\">Security</h2>\r\n<ul>\r\n<li>No known security issues.</li>\r\n</ul>"
    // }
  }
}
</script>



<style>
#release-date-header {
  margin-bottom: 30px;
  padding-bottom: 15px;
  position: relative;
  box-sizing: border-box;
  border-bottom: rgba(133, 133, 133, 0.53) 1px solid;
}
.release-container{
  padding-left: 25px;
}
.release-container li{
  padding-left: 15px;
}
.release-container h3{
  font-size: 1.3rem;
  font-weight: 450;
}
.release-container h1:first-child{
  font-size: 1.5rem;
  margin-bottom: 20px;
}
.release-container h1 {

  margin-top: 15px;
  margin-bottom: 15px;
  padding-left: -15px;
}
.release-container h1:after {
  display: block;
  margin-left: -25px;
  box-sizing: border-box;
  content: "";
  border-bottom: rgba(133, 133, 133, 0.53) 1px solid;
}

.release-container h2{
  font-size: 2em;
  margin-top: 15px;
  margin-bottom: 15px;
  padding-left: -15px;
}
.release-container h2:after {
  display: block;
  margin-left: -25px;
  box-sizing: border-box;
  content: "";
  border-bottom: rgba(133, 133, 133, 0.53) 1px solid;
}
</style>
